import { Ziggy } from '@php-beam/packages/frontend/src/hooks/useRoute/routes';
import {
  Config,
  default as ZiggyRouter,
  RouteParam,
  RouteParamsWithQueryOverload,
  Router,
} from 'ziggy-js';
import { AppRoutes } from '@php-beam/packages/frontend/src/types/ziggy';

export type RouteName = keyof AppRoutes;
export type DefaultParams =
  | RouteParamsWithQueryOverload
  | RouteParam
  | undefined;

export type RouteParams<B> = Record<
  B extends string ? B : never,
  DefaultParams
> & {
  [key: string]: DefaultParams | string;
};

const to_route = <
  T extends RouteName,
  B extends string | undefined = AppRoutes[T]['bindings'],
>(
  name: T | string,
  params?: string | RouteParams<B>,
  absolute?: boolean,
  config: Config = Ziggy as Config,
): string => {
  try {
    const isParamsString = typeof params === 'string';

    return `${ZiggyRouter(
      name as string,
      isParamsString ? undefined : (params as DefaultParams),
      absolute,
      config,
    )}${isParamsString ? `?${params}` : ''}`;
  } catch (e) {
    console.error(e);
    return '';
  }
};

export const route = to_route;

export const router = (config: Config = Ziggy as Config): Router => {
  return ZiggyRouter(undefined, undefined, undefined, config);
};

export const useRouter = () => {
  const query = (key: string) =>
    new URLSearchParams(window.location.search).get(key);

  return { to_route, route, router, query };
};
